import { makeRequest } from './make-request.api'


export const scrapeLinkRequest = (link) => {
  const params = new URLSearchParams()
  params.set('link', link)

  const queryStr = '?' + params.toString()
  return makeRequest('/scrape-link' + queryStr)
}